<script>
  import { SkeletonText } from "carbon-components-svelte";
  import Badge from "./Badge.svelte";
  import AccordionPagination from "lib/components/accordionPagination.svelte";
  export let rows = [];
  export let detailView = false;
  export let selectedRows = [];
  export let activityMappingView = false;
  export let selectedApps = [];
  export let loading = false;
  let listOfUniqueApplications = [];
  let searchTerm = "";
  let currentPage = 1;
  let pageSize = 5;
  let displayedApps = [];
  let displayedDetailApps = [];
  let filteredApps = [];

  let allRows = [];
  let initialRowsSet = false;

  $: {
    if (detailView && selectedRows.length > 0 && !activityMappingView) {
      displayedDetailApps = getUniqueApplications(selectedRows);
    }
  }

  $: {
    if (activityMappingView && rows.length > 0) {
      displayedApps = getUniqueApplications(rows);
    }
  }

  $: {
    if (!initialRowsSet && rows.length > 0) {
      allRows = [...rows];
      initialRowsSet = true;
    }
  }
  /// KPIs
  $: listOfUniqueApplications = Array.from(
    new Set(rows.map((row) => row.applications).flat())
  );

  $: {
    if (activityMappingView) {
      listOfUniqueApplications = Array.from(
        new Set(rows.map((row) => row.clearname).flat())
      );
    }
  }

  $: updateDisplay(currentPage, searchTerm, listOfUniqueApplications);
  $: rows = displayRows(selectedApps);

  function selectApp(application) {
    if (selectedApps.includes(application)) {
      selectedApps = selectedApps.filter((app) => app !== application);
      listOfUniqueApplications = [...listOfUniqueApplications, application];
    } else {
      selectedApps = [...selectedApps, application];
      listOfUniqueApplications = listOfUniqueApplications.filter(
        (app) => app !== application
      );
    }
  }

  function deselectApp(application) {
    selectedApps = selectedApps.filter((app) => app !== application);
    listOfUniqueApplications = [...listOfUniqueApplications, application];
  }

  function updateDisplay(currentPage, searchTerm, applications) {
    if (searchTerm) {
      filteredApps = applications.filter((app) =>
        app.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else {
      filteredApps = applications;
    }
    while (filteredApps.length <= (currentPage - 1) * pageSize) {
      currentPage--;
    }
    let tempDisplayed = filteredApps.filter(
      (app) => !selectedApps.includes(app)
    );
    if (activityMappingView) {
      filteredApps = tempDisplayed;
    }
    displayedApps = tempDisplayed.slice(
      (currentPage - 1) * pageSize,
      currentPage * pageSize
    );
    if (displayedApps.length < pageSize && tempDisplayed.length > pageSize) {
      let additionalApps = tempDisplayed
        .slice(currentPage * pageSize)
        .slice(0, pageSize - displayedApps.length);
      displayedApps = [...displayedApps, ...additionalApps];
    }
  }

  function displayRows(selectedApps) {
    let currentRows = allRows;
    if (selectedApps.length === 0) {
      return currentRows;
    }
    if (activityMappingView) {
      return currentRows.filter((row) =>
        selectedApps.every((app) => row.clearname !== app)
      );
    }
    let filteredRows = currentRows.filter((row) =>
      selectedApps.every((app) => row.applications.includes(app))
    );
    return filteredRows;
  }

  function getUniqueApplications(rows) {
    const uniqueApps = new Set();
    if (activityMappingView) {
      rows.forEach((row) => {
        uniqueApps.add(row.clearname);
      });
      return Array.from(uniqueApps);
    }
    rows.forEach((row) => {
      if (row.applications) {
        row.applications.forEach((app) => {
          uniqueApps.add(app);
        });
      }
    });
    return Array.from(uniqueApps);
  }
</script>

{#if !detailView}
  <div class={`budge ${selectedApps.length > 0 ? "app-selected" : ""}`}>
    {#each selectedApps as app}
      <Badge text={app} handleClick={() => deselectApp(app)} />
    {/each}
  </div>
{/if}
<div class="flex_wrapper">
  <div class="applications_wrapper">
    {#if loading}
      {#each Array(5) as _}
        <div class="app_only_name loading_wrapper">
          <SkeletonText />
        </div>
      {/each}
    {:else}
      {#if !detailView}
        <div class="search_wrapper">
          <!-- <SearchNew placeholder="Application" flexGrow={true} /> -->
          <div class="search">
            <div class="searchicon">
              <svg
                height="100%"
                viewBox="0 0 26 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.1466 24L14.8751 14.4151C14.077 15.0963 13.1462 15.6125 12.0828 15.9637C11.0193 16.3149 9.96862 16.4906 8.9306 16.4906C6.45541 16.4906 4.36059 15.6939 2.64614 14.1005C0.931688 12.5071 0.0744629 10.5574 0.0744629 8.25144C0.0744629 5.94545 0.928225 3.99371 2.63575 2.39623C4.3433 0.798742 6.42958 0 8.89461 0C11.3596 0 13.4579 0.797296 15.1894 2.39189C16.921 3.98645 17.7867 5.93492 17.7867 8.23728C17.7867 9.26149 17.5845 10.2704 17.1802 11.2642C16.7758 12.2579 16.2231 13.1069 15.5222 13.8113L25.7937 23.3585L25.1466 24ZM8.9306 15.6604C11.1705 15.6604 13.0582 14.9497 14.5938 13.5283C16.1293 12.1069 16.8971 10.3459 16.8971 8.24528C16.8971 6.14465 16.1293 4.38365 14.5938 2.96226C13.0582 1.54088 11.1705 0.830189 8.9306 0.830189C6.69074 0.830189 4.80302 1.54088 3.26744 2.96226C1.7319 4.38365 0.964121 6.14465 0.964121 8.24528C0.964121 10.3459 1.7319 12.1069 3.26744 13.5283C4.80302 14.9497 6.69074 15.6604 8.9306 15.6604Z"
                  fill="#1C1C20"
                />
              </svg>
            </div>
            <input
              type="text"
              bind:value={searchTerm}
              placeholder="Search for Application"
            />
          </div>
        </div>
      {/if}
      {#if detailView}
        {#each displayedDetailApps as application}
          <div class="app_only_name">
            {application}
          </div>
        {/each}
      {:else}
        {#each displayedApps as application}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div
            class="app_name {selectedApps.includes(application)
              ? 'selected'
              : ''}"
            on:click={() => {
              selectApp(application);
            }}
          >
            {application}
          </div>
        {/each}
      {/if}
    {/if}
  </div>
  <div class="pagination_wrapper">
    <AccordionPagination
      item="Applications"
      total={detailView ? displayedDetailApps.length : filteredApps.length}
      bind:currentpage={currentPage}
      itemsPerPage={pageSize}
    />
  </div>
</div>

<style>
  .search_wrapper {
    display: flex;
    gap: 0.5rem;
    flex-grow: 1;
    width: 100%;
    flex-shrink: 1;
    flex-grow: 1;
  }

  .search {
    border: 1px solid #1c1c20;
    border-radius: 0.5rem;
    width: 100%;
    display: flex;
    align-items: center;
    height: 3rem;
    padding: 0 1rem;
  }

  .searchicon {
    height: 1.5rem;
  }
  .flex_wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .kpi_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .applications_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .pagination_wrapper {
    padding-top: 1rem;
    border-top: 1px solid #d9d9d9;
  }

  .app_name.selected {
    border-color: var(--pax-black);
  }

  .app_name:hover {
    border-color: var(--pax-black);
  }

  .app_name {
    flex-shrink: 1;
    padding-left: 1rem;
    height: 3rem;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    cursor: pointer;
    border-radius: 0.5rem;
    background-color: var(--pax-smoke);
    border: 1px solid;
    border-color: var(--pax-smoke);
    color: var(--pax-black);
  }

  .app_only_name {
    flex-shrink: 1;
    padding-left: 1rem;
    height: 3rem;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    border-radius: 0.5rem;
    background-color: var(--pax-smoke);
    border: 1px solid;
    border-color: var(--pax-smoke);
    color: var(--pax-black);
  }

  .budge {
    margin-top: -12px;
    margin-bottom: 12px;
    padding-bottom: 4px;
  }

  .app-selected {
    border-bottom: 1px solid #c9c9c9;
  }

  .loading_wrapper {
    padding-right: 1rem;
    padding-top: 0.5rem;
    justify-content: center !important;
  }

  input {
    border: none;
    padding-left: 1rem;
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  input:focus,
  input:active {
    outline: none;
  }
</style>
